const UNSAFE_INLINE_SVG_URL = /^(javascript:|data:|vbscript:)/i;

export function sanitizeInlineSvgRoot(svg: SVGElement): void {
  svg.querySelectorAll('script, foreignObject').forEach((node) => {
    node.remove();
  });

  const stripUnsafeAttrs = (el: Element): void => {
    Array.from(el.attributes).forEach((attr) => {
      const name = attr.name.toLowerCase();
      if (name.startsWith('on')) {
        el.removeAttribute(attr.name);
        return;
      }
      if (name === 'href' || name === 'xlink:href' || name === 'src') {
        const v = attr.value.trim();
        if (UNSAFE_INLINE_SVG_URL.test(v)) {
          el.removeAttribute(attr.name);
        }
      }
    });
  };

  stripUnsafeAttrs(svg);
  svg.querySelectorAll('*').forEach(stripUnsafeAttrs);
}
